import React from 'react';
import { useForm } from 'react-hook-form';
import { withRouter } from 'react-router-dom';
import { useStateMachine } from 'little-state-machine';
import { compose } from 'redux';
import { connect } from 'react-redux';
import updateAction from './updateAction';
import Loader from '../../utils/Loader';
import { addOnboardDetails } from '../../redux/profile/profile.actions';
import Card from 'react-bootstrap/Card';
import { FullNameRegex } from '../../utils/regex';
const Step5 = ({ history, phone, full_name, addOnboardDetails }) => {
	const { register, handleSubmit, watch, errors } = useForm();

	const { state, action } = useStateMachine(updateAction);

	const onSubmit = async (data) => {
		if (!data.fullname) {
			data['fullname'] = full_name;
		}

		action(data);

		history.push('./final');
	};

	Loader.hide();
	return (
		<Card>
			<Card.Header className="setup-content" id="step-4">
				<h3>Your name:</h3>
			</Card.Header>
			<Card.Body>
				<form onSubmit={handleSubmit(onSubmit)}>
					<div className="form-group" style={{ marginTop: '10px' }}>
						<label className="control-label" htmlFor="fullname">
							Full Name:
						</label>
						<input
							type="text"
							className="form-control"
							name="fullname"
							ref={register({
								pattern: FullNameRegex,
								required: true,
							})}
							defaultValue={state.data?.fullname}
						/>

						<span className="profileError">
							{errors.fullname?.type === 'pattern' && 'Incorrect name.'}
							{errors.fullname?.type === 'required' && 'Name is required.'}
						</span>
					</div>

					<button
						aria-label="next"
						className="btn btn-primary nextBtn pull-right"
						type="submit"
					>
						Next
					</button>
				</form>
			</Card.Body>
		</Card>
	);
};

const mapStateToProps = (state) => {
	const { full_name } = state.rootReducer.userDetails;
	return {
		full_name,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		addOnboardDetails: (obj) => dispatch(addOnboardDetails(obj)),
	};
};

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(Step5);
